/* eslint-disable jira/filename-case */

import { QUICKSTART_TYPE, QUICKSTART_UI_STATUS, ROOT_TASK } from '../../common/constants.tsx';
import type { State } from './types.tsx';

export const initialState: State = {
	shouldRenderComponent: false,
	completedTaskList: [],
	hasSeenTasks: [],
	isDismissed: true, // Deprecated: use visibility instead
	isOpen: false, // Deprecated: use visibility instead
	isFocusedOn: false,
	openTask: '',
	projectState: null,
	hasNudgeActive: false,
	isQuickstartLoaded: false,
	nudgeStep: '',
	mountedNudges: [],
	hasEverSeenRoute: {
		'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false,
	},
	roadmapIsCreateEnabled: false,
	roadmapIsListEmpty: true,
	previousTaskGroupParents: [],
	currentTaskGroupParent: ROOT_TASK,
	currentTriggerForTaskGroupParent: '',
	selectedProjectTemplateKeyFromOnboarding: undefined, // could be undefined (e.g. nth users who don't go through project create)
	isCrossProjectBoardToPlanUpsell: false,
	canEditPlans: false,
	visibility: {
		[QUICKSTART_TYPE.JSM_BUSINESS_QUICKSTART_KEY]: QUICKSTART_UI_STATUS.NOT_LOADED,
		[QUICKSTART_TYPE.OLD_GLOBAL_QUICKSTART_KEY]: QUICKSTART_UI_STATUS.NOT_LOADED,
	},
	quickstartButtonRef: null,
	isOpenedViaButton: false,
};
